import React from 'react';
import './CancelButton.css';
class CancelButton extends React.Component {
  
  render() {
    return (
        <button
            className="moons-button-cancel"
            onClick={this.props.onClick}
        >
            {this.props.text}
        </button>
    )
  }

  componentDidMount() {
    this.setState({ someKey: 'otherValue' });
  }
}

export default CancelButton;



// WEBPACK FOOTER //
// ./src/views/Components/Presentation/CancelButton/CancelButton.js